import { ReducerRegistry } from 'store';
import {
  FETCH_CUSTOMERS,
  FETCH_CUSTOMER_BY_ID,
  FETCH_CUSTOMERS_CATEGORIES,
  CUSTOMER_ASYNC_START,
  CUSTOMER_ASYNC_END,
} from '../types';

const init_State = {
  loading: false,
  customers: [],
  customerDetails: {},
  customersCategories: [],
};

export const state = ReducerRegistry.register(
  'customers',
  (state = init_State, action) => {
    switch (action.type) {
      case FETCH_CUSTOMERS:
        return {
          ...state,
          customers: action.payload,
        };
      case FETCH_CUSTOMER_BY_ID:
        return {
          ...state,
          customerDetails: action.payload,
        };
      case FETCH_CUSTOMERS_CATEGORIES:
        return {
          ...state,
          customersCategories: action.payload,
        };
      case CUSTOMER_ASYNC_START:
        return {
          ...state,
          loading: true,
        };
      case CUSTOMER_ASYNC_END:
        return {
          ...state,
          loading: false,
        };
      default:
        return state;
    }
  },
);
